import { PortalButton } from '@custom-components';
import React from 'react';
import PropTypes from 'prop-types';

function EditingRenderActions(props) {
  const { editing, setEditing, formik, reqPermission, disabled } = props;
  const { isSubmitting, resetForm, isValid, dirty, handleSubmit } = formik;

  if (!editing)
    return (
      /**
       * When there are multiple reqPermissions, control the <PortalButton> component using the disabled prop.
       */
      <PortalButton disabled={disabled} reqPermission={reqPermission} onClick={() => setEditing(true)}>
        Edit
      </PortalButton>
    );

  return (
    <>
      <PortalButton
        btnTheme="blank"
        disabled={isSubmitting}
        onClick={() => {
          resetForm();
          setEditing(false);
        }}
      >
        Cancel
      </PortalButton>
      <PortalButton
        btnTheme="quaternary"
        disabled={isSubmitting || !(isValid && dirty)}
        onClick={handleSubmit}
        loading={isSubmitting}
      >
        Save
      </PortalButton>
    </>
  );
}

EditingRenderActions.propTypes = {
  editing: PropTypes.bool.isRequired,
  setEditing: PropTypes.func.isRequired,
  formik: PropTypes.shape({
    isSubmitting: PropTypes.bool.isRequired,
    resetForm: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }).isRequired,
  reqPermission: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

EditingRenderActions.defaultProps = {
  disabled: false
};

export default EditingRenderActions;
